// (a) Question prompt with LaTeX, type badge, marks, allocated time.
import type { Question } from '@/types';
import { MathText } from '@/components/exam/MathText';
import { ClockIcon, typeLabel } from '@/components/exam/icons';
import { ReportButton } from '@/components/ReportButton';

function fmtAlloc(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return s ? `${m}m ${s}s` : `${m}m`;
}

export function QuestionDisplay({ question }: { question: Question }) {
  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center gap-2 text-xs">
        <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600">
          {typeLabel(question.type)}
        </span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600">
          {question.maxMarks} {question.maxMarks === 1 ? 'mark' : 'marks'}
        </span>
        <span className="flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600">
          <ClockIcon className="h-3.5 w-3.5" /> {fmtAlloc(question.allocatedSeconds)}
        </span>
        <span className="ml-auto">
          <ReportButton questionId={question.id} />
        </span>
      </div>
      <div className="text-lg leading-relaxed text-ink">
        <MathText>{question.text}</MathText>
      </div>
    </div>
  );
}
